
import { Calendar, MapPin } from "lucide-react";
import { Voucher } from "@/types/voucher";

interface VoucherDetailsProps {
  voucher: Voucher;
}

export function VoucherDetails({ voucher }: VoucherDetailsProps) {
  return (
    <div className="space-y-4">
      {/* Voucher image */}
      <div 
        className="w-full h-48 bg-gray-800 rounded-md"
        style={{
          backgroundImage: voucher.image ? `url(${voucher.image})` : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      
      {/* Venue details */}
      <div className="flex items-start gap-2">
        <MapPin className="h-5 w-5 text-[#089BDF] mt-0.5" />
        <div>
          <h3 className="font-semibold">{voucher.venue.name}</h3>
          <p className="text-sm text-gray-400">{voucher.venue.address}</p>
        </div>
      </div>
      
      {/* Voucher details */}
      <div className="rounded-md border border-gray-800 p-4">
        <p className="text-sm leading-relaxed">{voucher.description}</p>
      </div>
      
      {/* Sponsor message */}
      {voucher.sponsorMessage && (
        <div className="rounded-md bg-gray-900 p-4">
          <h4 className="text-sm font-semibold mb-1">Message from {voucher.sponsorName}</h4>
          <p className="text-sm text-gray-400">{voucher.sponsorMessage}</p>
        </div>
      )}
      
      {/* Expiration */}
      <div className="flex items-center gap-2 text-sm text-gray-400">
        <Calendar className="h-4 w-4" />
        <span>Expires on {new Date(voucher.expiresAt).toLocaleDateString()}</span>
      </div>
    </div>
  );
}
